// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { ScanProfileTierSchema } from '../inputTypeSchemas/ScanProfileTierSchema'

/////////////////////////////////////////
// SCAN PROFILE SCHEMA
/////////////////////////////////////////

export const ScanProfileSchema = z.object({
  systemTier: ScanProfileTierSchema.nullable(),
  id: z.string(),
  tenantId: z.string().nullable(),
  name: z.string(),
  isSystem: z.boolean(),
  createdBy: z.string().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})

export type ScanProfile = z.infer<typeof ScanProfileSchema>

export default ScanProfileSchema;
